function frozenWords(value) {
    return Object.freeze(value.trim().split(/\s+/));
}

function frozenMappings(value) {
    return Object.freeze(Object.fromEntries(
        value.trim().split(/\s+/).map((entry) => entry.split("=")),
    ));
}

export const PYODIDE_IMPORT_CATALOG_PROVENANCE = Object.freeze({
    version: "0.29.5",
    pythonStdlibSha256: "831fd1e535084b972f87c6a35275de3d236efd5166f5e77ce89497710635e73c",
    runtimeWasmSha256: "54309a5a2cfd757b1f0fdbc9093c92503f7b341500110329d932487183912718",
    lockSha256: "14d2c2dba101277999e17135e653d8f15389ad1437f53eae213bf0c3cdff723d",
});

// These literals keep authoring warnings available before the ignored runtime
// assets are materialized. Their verified source assets are pinned above.
export const PYODIDE_STDLIB_IMPORT_ROOTS = frozenWords(`
    __future__ __hello__ __phello__ _android_support _apple_support
    _collections_abc _colorize _compat_pickle _compression _ios_support
    _markupbase _opcode_metadata _py_abc _pydatetime _pyio _pylong _pyodide
    _pyrepl _sitebuiltins _strptime _threading_local _weakrefset abc antigravity
    argparse ast asyncio base64 bdb bisect bz2 cProfile calendar cmd code codecs
    codeop collections colorsys compileall concurrent configparser contextlib
    contextvars copy copyreg csv ctypes dataclasses datetime decimal difflib dis
    doctest email encodings enum filecmp fileinput fnmatch fractions ftplib
    functools genericpath getopt getpass gettext glob graphlib gzip hashlib heapq
    hmac html http imaplib importlib inspect io ipaddress json keyword linecache
    locale logging mailbox mimetypes modulefinder multiprocessing netrc ntpath
    nturl2path numbers opcode operator optparse os pathlib pdb pickle pickletools
    pkgutil platform plistlib poplib posixpath pprint profile pstats pty
    py_compile pyclbr pydoc pyodide queue quopri random re reprlib rlcompleter
    runpy sched secrets selectors shelve shlex shutil signal site smtplib socket
    socketserver sre_compile sre_constants sre_parse stat statistics string
    stringprep struct subprocess symtable sysconfig tabnanny tarfile tempfile
    textwrap this threading timeit token tokenize tomllib trace traceback
    tracemalloc tty types typing unittest urllib uuid warnings wave weakref
    webbrowser wsgiref xml xmlrpc zipapp zipfile zipimport zoneinfo
`);

export const PYODIDE_BUILTIN_IMPORT_ROOTS = frozenWords(`
    _abc _ast _asyncio _bisect _blake2 _bz2 _codecs _codecs_cn _codecs_hk
    _codecs_iso2022 _codecs_jp _codecs_kr _codecs_tw _collections _contextvars
    _csv _ctypes _datetime _decimal _elementtree _functools _heapq _imp _io
    _json _locale _lsprof _md5 _multibytecodec _opcode _operator _pickle
    _posixsubprocess _pyodide_core _queue _random _sha1 _sha2 _sha3 _signal
    _socket _sre _stat _statistics _string _struct _suggestions _symtable
    _sysconfig _thread _tokenize _tracemalloc _typing _warnings _weakref
    _zoneinfo array atexit binascii builtins cmath errno faulthandler gc
    itertools marshal math mmap posix pyexpat select sys time unicodedata zlib
`);

// Only distribution names that differ from their import root need encoding.
// Same-name locked packages and imports absent from the lock both use the root.
export const PYODIDE_LOCKED_PACKAGE_NAME_OVERRIDES = frozenMappings(`
    _argon2_cffi_bindings=argon2-cffi-bindings _distutils_hack=setuptools
    _hashlib=hashlib _lzma=lzma
    _pydecimal=pydecimal _pyrsistent_version=pyrsistent _pytest=pytest
    _sqlite3=sqlite3 _ssl=ssl _yaml=pyyaml _zengl=zengl
    annotated_types=annotated-types argon2=argon2-cffi async_timeout=async-timeout
    attr=attrs audioop=audioop-lts awkward_cpp=awkward-cpp bigtests=screed
    bilby_cython=bilby.cython Bio=biopython BioSQL=biopython
    boost_histogram=boost-histogram bottleneck=Bottleneck bs4=beautifulsoup4
    cartopy=Cartopy cbor_diag=cbor-diag charset_normalizer=charset-normalizer
    CoolProp=coolprop Crypto=pycryptodome css_inline=css-inline
    cv2=opencv-python cvxpy=cvxpy-base dateutil=python-dateutil erfa=pyerfa
    fitz=PyMuPDF flint=python-flint flirt=python-flirt fontTools=fonttools
    google=protobuf google_crc32c=google-crc32c imgui_bundle=imgui-bundle
    InSpice=inspice IPython=ipython isympy=sympy jinja2=Jinja2
    lakers=lakers-python lazy_object_proxy=lazy-object-proxy magic=python-magic
    markupsafe=MarkupSafe memory_allocator=memory-allocator
    more_itertools=more-itertools mpl_toolkits=matplotlib mypyc=mypy
    nacl=pynacl netCDF4=netcdf4 PhiSpyModules=phispy
    PhiSpyRepeatFinder=phispy pi_heif=pi-heif PIL=Pillow
    pillow_heif=pillow-heif pkg_resources=setuptools ppl=pplpy
    pure_eval=pure-eval pygame=pygame-ce pygments=Pygments pylab=matplotlib
    pylimer_tools=pylimer-tools pymupdf=PyMuPDF pyodide_http=pyodide-http
    pysat=python-sat pytest_asyncio=pytest-asyncio
    pytest_benchmark=pytest-benchmark python_calamine=python-calamine
    python_solvespace=python-solvespace pywt=pywavelets rpds=rpds-py
    ruamel=ruamel.yaml shapefile=pyshp sisl_toolbox=sisl
    skimage=scikit-image sklearn=scikit-learn smart_open=smart-open
    stack_data=stack-data taglib=pytaglib tiktoken_ext=tiktoken tlz=toolz
    tomli_w=tomli-w tree_sitter=tree-sitter tree_sitter_go=tree-sitter-go
    tree_sitter_java=tree-sitter-java tree_sitter_python=tree-sitter-python
    typing_extensions=typing-extensions typing_inspection=typing-inspection
    unix_timezones=pyodide-unix-timezones vega_datasets=vega-datasets
    yaml=pyyaml
`);
